import React from "react";
import { Col, Container, Row } from "react-bootstrap";

export const Footer: React.FC = () => {
  return (
    <footer className="footer bg-white py-4 px-3">
      <Container>
        <Row className="justify-content-around">
          <Col xs={12} md={4}>
            <a
              href="tel:12368882596"
              className="d-block text-center text-decoration-none text-black"
            >
              TEL: +1 (236)-888-2596
            </a>
          </Col>

          <Col xs={12} md={4}>
            <a
              href="mailto:ahmad.aryan83@gmail.com"
              className="d-block text-center text-decoration-none text-black"
            >
              ahmad.aryan83@gmail.com
            </a>
          </Col>

          <Col xs={12} md={4}>
            <a
              href="https://www.shamautoparts.com"
              className="d-block text-center text-decoration-none text-black"
            >
              www.shamautoparts.com
            </a>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};
